import { createBrowserRouter } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { AuthRoute } from './AuthRoute';
import { RootRedirect } from './RootRedirect';

// Pages
import { Login } from '@/pages/Login';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { ResetPassword } from '@/pages/ResetPassword';
import { Games } from '@/pages/Games';
import { Profile } from '@/pages/Profile';
import { Join } from '@/pages/Join';
import { SettlementViewer } from '@/pages/SettlementViewer';
import { GridMapViewer } from '@/pages/GridMapViewer';
import { GridMapGameView } from '@/pages/GridMapGameView';
import { GridCombatSimulator } from '@/pages/GridCombatSimulator';
import { StretchSimulator } from '@/pages/StretchSimulator';
import { NewGame } from '@/pages/NewGame';
import { Play } from '@/pages/game/Play';
import { NotFound } from '@/pages/NotFound';
import { AdminRoute } from './AdminRoute';
import { AdminDashboard } from '@/pages/admin/AdminDashboard';
import { DungeonList } from '@/pages/admin/DungeonList';
import { DungeonEditor } from '@/pages/admin/DungeonEditor';

export const router = createBrowserRouter([
  // Root redirect - goes to /games if logged in, /login if not
  { path: '/', element: <RootRedirect /> },

  // Auth routes (redirect if logged in)
  {
    element: <AuthRoute />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/forgot-password', element: <ForgotPassword /> },
      { path: '/reset-password', element: <ResetPassword /> },
    ],
  },

  // Protected routes
  {
    element: <ProtectedRoute />,
    children: [
      { path: '/games', element: <Games /> },
      { path: '/new-game', element: <NewGame /> },
      { path: '/profile', element: <Profile /> },
      { path: '/join', element: <Join /> },
      { path: '/settlement-viewer', element: <SettlementViewer /> },
      { path: '/game/:id/play', element: <Play /> },
    ],
  },

  // Public tool routes (no auth required, fully client-side)
  { path: '/combat-simulator', element: <GridCombatSimulator /> },
  { path: '/grid-map-viewer', element: <GridMapViewer /> },
  { path: '/grid-map-game', element: <GridMapGameView /> },
  { path: '/stretch-simulator', element: <StretchSimulator /> },

  // Admin routes (requires isAdmin)
  {
    element: <AdminRoute />,
    children: [
      { path: '/admin', element: <AdminDashboard /> },
      { path: '/admin/dungeons', element: <DungeonList /> },
      { path: '/admin/dungeons/:id/edit', element: <DungeonEditor /> },
    ],
  },

  // 404
  { path: '*', element: <NotFound /> },
]);
